import React from 'react';
import { App } from '../../app/AppSingleton';
import { AppSignals } from '../../app/AppSignals';
import { TaskEditorCore } from './TaskEditorCore';
import './TaskAdd.css';
import {ViewModeEnum} from "../../models/view-types";
import {EntityID} from "../../models/types";

interface TaskAddProps {
	columnId: EntityID;
	boardId: EntityID;

	onTaskAdded?: (() => void) | undefined;
	onTaskDeleted?: () => void;
	onCancel?: (() => void) | undefined;
	autoFocus?: boolean;
	showCancel?: boolean;
}

interface TaskAddState {
	isAdding: boolean;
}

const messages = {
	"title_placeholder":"Введите название карточки...",
	"hint":"Enter — сохранить, Esc — отмена",
	"button_caption":"Добавить карточку"
}

class TaskAdd extends React.Component<TaskAddProps, TaskAddState> {
	private unsubscribe?: () => void;

	constructor(props: TaskAddProps) {
		super(props);
		this.state = {
			isAdding: false,
		};

		//		console.log("construct", props.columnId);
	}

	// ✅ Стрелочные функции (коллбэки/обработчики)
	private handleSubmit = async (title: string): Promise<void> => {
		this.setState({ isAdding: false });

		try {
			await App.getInstance().taskAdd(this.props.columnId, title.trim());
			AppSignals.cancelTaskAdd.emit(this.props.columnId);

			if (this.props.onTaskAdded) {
				this.props.onTaskAdded();
			}
		} catch (error) {
			console.error('Error creating task:', error);
			throw error;
		}
	};

	private handleCancel = (): void => {
		this.setState({ isAdding: false });
		AppSignals.cancelTaskAdd.emit(this.props.columnId);

		if (this.props.onCancel) {
			this.props.onCancel();
		}
	};

	private startAdding = (): void => {
		this.setState({ isAdding: true });
	};

	// ✅ Обычные методы (вызываются напрямую)
	private renderAddButton(): React.ReactNode {
		return (
			<button
				onClick={this.startAdding}
				className="task-add__button"
				aria-label={messages.button_caption}
			>
				<svg
					className="task-add__button-icon"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
				</svg>
				<span className="task-add__button-text">
					{messages.button_caption}
				</span>
			</button>
		);
	}

	private renderTaskEditor(): React.ReactNode {
		const { autoFocus = true, showCancel = true } = this.props;
		const isModalMode = false; // this.props.onTaskAdded !== undefined;

		return (
			<TaskEditorCore
				boardId={this.props.boardId}
				mode="add"
				initialTitle=""
				onSubmit={this.handleSubmit}
				onCancel={this.handleCancel}
				autoFocus={true || autoFocus || isModalMode}
				showCancelButton={showCancel}
				className="task-editor-core--add"
				inputClassName="task-editor-core__input--add"
				placeholder={messages.title_placeholder}
				hintText={messages.hint}
			/>
		);
	}


	shouldComponentUpdate(nextProps: Readonly<TaskAddProps>, nextState: Readonly<TaskAddState>, nextContext: any): boolean {
		//console.log("update add", this.props.columnId, nextState.isAdding);
		return true;
	}

	// ✅ Lifecycle методы (обычные, как определено React)
	public componentDidMount(): void {
		this.unsubscribe = AppSignals.activateTaskAdd.subscribe((payloadColumnId: string) => {
			if (payloadColumnId !== this.props.columnId) return;
			this.setState({ isAdding: true });
		});
		//console.log("mount add", this.props.columnId, this.state.isAdding);
	}

	public componentWillUnmount(): void {
		//		console.log("unmount", this.props.columnId);
		if (this.unsubscribe) {
			this.unsubscribe();
		}
	}

	// ✅ Обычный метод рендеринга (вызывается только React)
	public render(): React.ReactNode {
		const { isAdding } = this.state;
		const { onTaskAdded } = this.props;
		const isModalMode = false; // onTaskAdded !== undefined;
		const showAddButton = !isModalMode && !isAdding;

		//console.log("render add", this.props.columnId, isAdding);
		if (showAddButton) {
			//console.log("mode", App.getInstance().getViewMode());
			if (App.getInstance().getViewMode() === ViewModeEnum.List) {
				return null;
			}
			return this.renderAddButton();
		}

		return this.renderTaskEditor();
	}
}

export default TaskAdd;